var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserAvatar',{staticClass:"mr-4",attrs:{"name":_vm.name,"icon":_vm.icon,"color-set":_vm.color,"size":"40"}})}
var staticRenderFns = []

export { render, staticRenderFns }